module.exports = __webpack_public_path__ + "img/youjian.0ea6cf5c.png";